import React, { useEffect, useState, useRef } from 'react';
import { Modal, Space, Spin, Descriptions, Button, Select as AntSelect } from 'antd';
import { DatePicker } from 'antd';
import { LIC_FETCH_BILL, LIC_PAY_BILL } from '../../Utils/appConstants';
import { getRequest, postRequest } from '../../Utils/AppApi';
import { useHistory } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'antd/dist/antd.css';
import moment from 'moment';

function LicBillPayment(props) {
    const dateFormat = 'DD/MM/YYYY';
    const queryDateFormat = 'YYYY-MM-DD';

    const history = useHistory();

    const [isModalViewBill, setIsModalViewBill] = useState(false);
    const [getDataField, setDataField] = useState({});
    const [getDataError, setDataError] = useState({});
    const [getCustomerInfo, setCustomerInfo] = useState({});
    const [paymentId, setPaymentId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [commissionData, setCommissionData] = useState(null);
    const [paymentLoading, setPaymentLoading] = useState(false);

    const onChangeValue = (e) => {
        const { name, value } = e.target;
        setDataField(prev => ({ ...prev, [name]: value }));
    };

    const onChangeDatePicker = (date, dateString) => {
        if (date) {
            const formattedDate = moment(date).format(queryDateFormat);
            setDataField(prev => ({
                ...prev,
                dob: formattedDate
            }));
        }
    };

    const FormValidate = () => {
        let formObject = {};
        let formValid = true;

        if (!getDataField.accountNumber || !getDataField.accountNumber.trim()) {
            formObject.accountNumber = true;
            formValid = false;
        }
        if (!getDataField.dob) {
            formObject.dob = true;
            formValid = false;
        }
        if (getDataField.mobileNumber && !/^[0-9]{10}$/.test(getDataField.mobileNumber)) {
            formObject.mobileNumber = true;
            formValid = false;
        }
        if (getDataField.emailId && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(getDataField.emailId)) {
            formObject.emailId = true;
            formValid = false;
        }

        setDataError(formObject);
        return formValid;
    };

    const viewBill = () => {
        if (!FormValidate()) return;

        setLoading(true);

        const payload = {
            account: getDataField.accountNumber,
            cust_mbl: getDataField.mobileNumber || "",
            emailID: getDataField.emailId || "",
            dob: getDataField.dob
        };

        postRequest(LIC_FETCH_BILL, payload, history).then((response) => {
            if (response.success === true) {
                setIsModalViewBill(true);
                setCommissionData(response.commissionData);
                setPaymentId(response.bbpsTxId);
                setDataField(prev => ({ 
                    ...prev, 
                    amount: response.data?.payamount || response.data?.billedamount 
                }));
                setCustomerInfo({
                    customerName: response.data?.customerName || 'N/A',
                    billNumber: response.data?.LicbillNumber || 'N/A',
                    billAmount: response.data?.billedamount || 0,
                    payableAmount: response.data?.payamount || 0,
                    dueDate: response.data?.dueDate || 'N/A',
                    dueFrom: response.data?.dueFrom || 'N/A',
                    billDate: response.data?.billdate || 'N/A',
                    licValidationId: response.data?.LicvalidationId,
                    licBillId: response.data?.LicbillId,
                    billFetchId: response.data?.billFetchId
                });
            } else {
                toast.error(response.message || "Failed to fetch LIC bill");
            }
            setLoading(false);
        }).catch((error) => {
            console.error(error);
            toast.error("Something went wrong while fetching LIC bill");
            setLoading(false);
        });
    };

    const billPayment = () => {
        if (!getDataField.amount || parseFloat(getDataField.amount) <= 0) {
            toast.error("Invalid bill amount");
            return;
        }

        setPaymentLoading(true);

        const payload = {
            bbpsTxId: paymentId,
            amount: getDataField.amount,
            billFetchId: getCustomerInfo.billFetchId,
            cust_mbl: getDataField.mobileNumber || "",
            emailID: getDataField.emailId || "",
            LicvalidationId: getCustomerInfo.licValidationId,
            LicbillId: getCustomerInfo.licBillId
        };

        postRequest(LIC_PAY_BILL, payload, history).then((response) => {
            if (response.success === true) {
                toast.success(response.message || "LIC bill payment successful!");
                setIsModalViewBill(false);
                setDataField({});
                setCustomerInfo({});
                setCommissionData(null);
                setPaymentId(null);
                setTimeout(() => {
                    history.push('/transaction-history');
                }, 2000);
            } else {
                toast.error(response.message || "Payment failed");
            }
        }).catch((error) => {
            console.error(error);
            toast.error("Something went wrong during payment");
        }).finally(() => {
            setPaymentLoading(false);
        });
    };

    const handleHideModal = () => {
        setIsModalViewBill(false);
    };

    return (
        <div>
            {loading && (
                <div className={'parentDisable'} style={{ width: '100%' }}>
                    <Space direction="vertical" style={{ width: '100%' }}>
                        <Spin tip="Loading..." size="large">
                            <div className="spin-loader" />
                        </Spin>
                    </Space>
                </div>
            )}

            <div className='pt-4'>
                <h4 className='mb-3'>LIC Premium Payment</h4>

                <div className="form-group">
                    <input
                        type="text"
                        className={`form-control normal-light ${getDataError.accountNumber ? "is-invalid" : ""}`}
                        placeholder="Enter LIC Policy Number"
                        name="accountNumber"
                        onChange={onChangeValue}
                    />
                    {getDataError.accountNumber && <span className="error text-danger">LIC policy number is required</span>}
                </div>

                <div className="form-group">
                    <input
                        type="text"
                        className={`form-control normal-light ${getDataError.mobileNumber ? "is-invalid" : ""}`}
                        placeholder="Mobile Number (Optional)"
                        name="mobileNumber"
                        onChange={onChangeValue}
                        maxLength={10}
                    />
                    {getDataError.mobileNumber && <span className="error text-danger">Please enter valid 10-digit mobile number</span>}
                </div>

                <div className="form-group">
                    <input
                        type="email"
                        className={`form-control normal-light ${getDataError.emailId ? "is-invalid" : ""}`}
                        placeholder="Email ID (Optional)"
                        name="emailId"
                        onChange={onChangeValue}
                    />
                    {getDataError.emailId && <span className="error text-danger">Please enter valid email address</span>}
                </div>

                <div className="form-group">
                    <DatePicker
                        format={dateFormat}
                        className={`form-control normal-light ${getDataError.dob ? "is-invalid" : ""}`}
                        placeholder="Select Date of Birth"
                        onChange={onChangeDatePicker}
                        style={{ width: '100%' }}
                    />
                    {getDataError.dob && <span className="error text-danger">Date of birth is required</span>}
                </div>

                <div className='row pt-2'>
                    <div className='col-12'>
                        <button
                            type="button"
                            className="btn btn-danger mb-2 btn-block"
                            onClick={viewBill}
                            disabled={loading}
                            style={{ backgroundColor: '#C9262C', borderColor: '#C9262C' }}
                        >
                            Fetch Bill
                        </button>
                    </div>
                </div>
            </div>

            <ToastContainer position="top-center" autoClose={5000} />

            {isModalViewBill && (
                <Modal
                    title="LIC Bill Details"
                    width={540}
                    open={isModalViewBill}
                    onCancel={handleHideModal}
                    centered
                    footer={[
                        <Button
                            key="cancel"
                            size="large"
                            onClick={handleHideModal}
                            style={{ marginRight: '32px', minWidth: '120px' }}
                        >
                            Cancel
                        </Button>,
                        <Button
                            key="submit"
                            type="primary"
                            size="large"
                            loading={paymentLoading}
                            disabled={!getDataField.amount || parseFloat(getDataField.amount) <= 0}
                            onClick={billPayment}
                            style={{
                                minWidth: '160px',
                                backgroundColor: '#C9262C',
                                borderColor: '#C9262C',
                                color: '#FFDD09'
                            }}
                        >
                            {paymentLoading ? 'Processing...' : `Pay ₹${getDataField.amount || '0'}`}
                        </Button>
                    ]}
                >
                    {paymentLoading ? (
                        <div style={{ textAlign: 'center', padding: '40px 0' }}>
                            <Spin tip="Processing Payment..." size="large" />
                        </div>
                    ) : getCustomerInfo && Object.keys(getCustomerInfo).length > 0 ? (
                        <div style={{ padding: '8px 0' }}>
                            <Descriptions bordered column={1} size="small">
                                <Descriptions.Item label="Customer Name">
                                    <strong>{getCustomerInfo.customerName}</strong>
                                </Descriptions.Item>
                                <Descriptions.Item label="Policy/Bill Number">
                                    {getCustomerInfo.billNumber}
                                </Descriptions.Item>
                                <Descriptions.Item label="Due Date">
                                    {getCustomerInfo.dueDate}
                                </Descriptions.Item>
                                <Descriptions.Item label="Due From">
                                    {getCustomerInfo.dueFrom}
                                </Descriptions.Item>
                                <Descriptions.Item label="Bill Date">
                                    {getCustomerInfo.billDate}
                                </Descriptions.Item>
                                <Descriptions.Item label="Bill Amount">
                                    <span style={{ fontSize: '16px', fontWeight: '500' }}>
                                        ₹{getCustomerInfo.billAmount}
                                    </span>
                                </Descriptions.Item>
                                <Descriptions.Item label="Payable Amount">
                                    <span style={{
                                        fontSize: '20px',
                                        fontWeight: '600',
                                        color: '#C9262C'
                                    }}>
                                        ₹{getCustomerInfo.payableAmount}
                                    </span>
                                </Descriptions.Item>
                            </Descriptions>

                            {commissionData && (
                                <div style={{ marginTop: 20 }}>
                                    <h5 style={{ marginBottom: 10, color: '#C9262C' }}>Fee & Commission Details</h5>
                                    <Descriptions bordered column={1} size="small">
                                        <Descriptions.Item label="Service Charge">
                                            ₹{Number(commissionData.serviceAmount || 0).toFixed(2)}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="Commission">
                                            ₹{Number(commissionData.commissionAmount || 0).toFixed(2)}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="TDS">
                                            ₹{Number(commissionData.tdsAmount || 0).toFixed(2)}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="Total Payable">
                                            <span style={{
                                                fontSize: '18px',
                                                fontWeight: 'bold',
                                                color: '#C9262C'
                                            }}>
                                                ₹{(parseFloat(getCustomerInfo.payableAmount || getCustomerInfo.billAmount) + 
                                                   parseFloat(commissionData.serviceAmount || 0)).toFixed(2)}
                                            </span>
                                        </Descriptions.Item>
                                    </Descriptions>
                                </div>
                            )}

                            <div style={{
                                background: '#FFF9E6',
                                border: '1px solid #FFDD09',
                                borderRadius: '6px',
                                padding: '12px',
                                marginTop: 20,
                                fontSize: '14px'
                            }}>
                                <ul style={{ paddingLeft: '18px', margin: '0' }}>
                                    <li>Please verify all details before making payment</li>
                                    <li>Payment confirmation may take a few minutes</li>
                                    <li>For any issues, please contact support with your transaction ID</li>
                                </ul>
                            </div>
                        </div>
                    ) : (
                        <p style={{ textAlign: 'center', padding: '30px 0' }}>No bill information available.</p>
                    )}
                </Modal>
            )}
        </div>
    );
}

export default LicBillPayment;